import React, { useState, useEffect, useMemo } from 'react';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import { Button, Spin, Card, message, Breadcrumb, Select } from 'antd';
import { searchUser, assignUsers, listTeamMembers } from '../../../apis/teams';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import debounce from 'lodash.debounce';
import ProtectAdminRoute, { ProtectTeamAdminRoute } from './custom/adminRoute';
import { connect } from 'react-redux';

const styles = {
  "notiText": {
    fontSize: 14,
    fontWeight: 500
  },
  "titlePage": {
    fontSize: 20,
    fontWeight: 700
  },
  "tableToolbar": {
    marginBottom: 16,
  }
}

function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const fetchRef = React.useRef(0);
  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        console.log(newOptions);
        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  );
}

const AssignTeamUser = ({ user }) => {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const [role, setRole] = useState({});
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const fetchTeamServices = async () => {
      setLoading(true)
      const data = await listTeamMembers(id);
      setMembers(data);
      setLoading(false);
    }
    fetchTeamServices();
  }, [id]);


  const handleSearchUser = async (searchText) => {
    try {
      const { data: result } = await searchUser(searchText);
      const newResult = result.map((r) => ({
        value: r.id,
        label: r.email
      }));
      return newResult
    } catch (error) {
      message.error("The system can not fetch users. Please try again later")
      return null
    }
  }

  const handleSaveAssignment = async () => {
    try {
      const result = await assignUsers(id, {
        data: options && options.map((option) => {
          return {
            user_id: option.value,
            role: role[option.value] || 'team_dev'
          }
        })
      })
      setSelected([]);
      setRole({});
      setOptions([]);
      message.success('Assigned users successfully')
    } catch (error) {
      console.log('error', error);
      message.error('The system can not handle request. Please try again later')
    }
  }

  const isTeamAdmin = useMemo(() => {
    const currentUserId = (user && user.id) || null;

    if (currentUserId && members) {
      const findCurrentUser = members.find((member) => {
        return ((member.user.id).toString() === currentUserId.toString() && member.role === "team_admin");
      });

      if (findCurrentUser) {
        return true
      }
    }
    return false;
  }, [members, user])

  return (
    <AdminLayoutWrapper>
      <Spin spinning={loading}>
        {!loading &&
          <ProtectTeamAdminRoute
            isTeamAdmin={isTeamAdmin}
          >
            <div style={{ padding: '0px 0px 16px 0px' }}>
              <Breadcrumb>
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/admin/teams/me`}>Manage Team</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/admin/teams/${id}/members`}>Team Members</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  Assign Team Members
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Card>
              {/* <Select
          mode="multiple"
          allowClear={false}
          style={{ minWidth: '300px' }}
          placeholder={'Please select user'}
          value={selected}
          optionLabelProp="email"
          onSearch={debounceFetcher}
          // options={listUsers}
          notFoundContent={fetching ? <Spin size="small" /> : null}
        >
          {listUsers && listUsers.map((option) => {
            return (
              <Select.Option key={option.id} value={option.id} >
                {option.email}
              </Select.Option>
            )
          })}
        </Select> */}
              <div style={{
                margin: '0px 0px 10px 0px'
              }}>
                <i>Please search and select users in input below. You can select multiple users</i>
              </div>
              <DebounceSelect
                mode="multiple"
                value={selected}
                placeholder="Select users"
                fetchOptions={handleSearchUser}
                onChange={(newValue, option) => {
                  console.log(option)
                  setSelected(newValue);
                  setOptions(option);
                }}
                style={{
                  minWidth: '500px',
                }}
              />
              {selected && selected.length > 0 &&
                <div style={{
                  margin: '15px 0px 10px 0px'
                }}>
                  <div style={{
                    marginBottom: '5px'
                  }}><b>Your selected users list.</b></div>
                  {
                    options && options.map((option) => {
                      return (
                        <Card key={option.value} style={{ width: 500 }}>
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                          }}>
                            {option.label}
                            <Select
                              defaultValue="team_dev"
                              style={{ width: 120 }}
                              onSelect={(value) => {
                                setRole((pre) => {
                                  return {
                                    ...pre,
                                    [option.value]: value
                                  }
                                })
                              }}
                              value={role[option.value]}
                            >
                              <Select.Option value="team_admin">Team Admin</Select.Option >
                              <Select.Option value="team_dev">Team Dev</Select.Option >
                            </Select>
                          </div>
                        </Card>
                      )
                    })
                  }
                  <div style={{ marginTop: 10 }}>
                    <Button onClick={handleSaveAssignment} type="primary">Save</Button>
                  </div>
                </div>
              }
            </Card>
          </ProtectTeamAdminRoute>

        }
      </Spin>
    </AdminLayoutWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.app.user
  }
}

export default connect(mapStateToProps)(AssignTeamUser);
